import $ from 'jquery';
import debounce from 'lodash/debounce';
import textHeight from 'text-height';

class FancyHover {
    constructor(node, options) {
        this.o = $.extend(true, {
            background: true,
            hover: true
        }, options);
        this.node = node;
        this.$node = $(node);

        if (!window.descendersMap) window.descendersMap = {};
        this.events();
        this.createLine();
    }

    events() {
        $(window)
            // .on('resize', debounce(this.createLine.bind(this), 200))
            .on('resize', debounce(() => {
                // this.createLine();
                setTimeout(this.createLine.bind(this), 500);
            }, 200))
            .on('load', () => {
                this.createLine();
                // this.createLine.bind(this)
            });
    }

    createLine() {
        this.renderHelperEm();
        this.renderLines();
        this.setHover();
    }

    renderHelperEm() {
        if (!this.$node.find('.fancy-hover-em').length) {
            this.$node.wrapInner('<em class="fancy-hover-em" />');
        }
        this.$em = this.$node.find('.fancy-hover-em');
    }

    renderLines() {
        let fontColor = this.$em.css('color'),
            fontFamily = this.$em.css('font-family'), /*.replace(/[^\w\s]/gi, '').replace(/ /gi, '-').toLowerCase(),*/
            fontSize = parseFloat(this.$em.css('font-size')),
            letterHeight = this.getLetterHeight(fontFamily, fontSize),
            strokeWidth = this.getStrokeWidth(fontFamily, fontSize);

        this.bottom = Math.round(letterHeight - strokeWidth * 1.5 + 1.5);
        this.width = this.getAbsoluteWidth();

        this.$em.css({
            backgroundImage: `linear-gradient(to bottom, ${fontColor} 0%, ${fontColor} 100%)`,
            backgroundPosition: `-${this.o.hover === true ? this.width : 0}px ${this.bottom}px`,
            backgroundSize: `100% ${strokeWidth}px`
        });
        if (this.o.background) {
            let backgroundColor = this.getRealBackgroundColor(this.$node);

            this.$em.css({
                textShadow: this.getTextShadow(fontSize, backgroundColor)
            });
        }
        setTimeout(() => this.$em.css('transition', `background-position ${this.getTransitionDuration()}ms`), 1);
    }

    setHover() {
        this.timeout = () => {};

        if (this.o.hover !== false) {
            clearTimeout(this.timeout);
            this.$node
                .off('mouseenter')
                .off('mouseleave')
                .on('mouseenter', () => {
                    if (this.o.hover === true) {
                        this.$em.css({
                            backgroundPosition: `0px ${this.bottom}px`
                        });
                    } else if (this.o.hover === 'alternate') {
                        this.$em.css({
                            transition: `background-position ${this.getTransitionDuration()}ms`,
                            backgroundPosition: `${this.width}px ${this.bottom}px`
                        });
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            this.$em.css({
                                transition: 'none',
                                backgroundPosition: `-${this.width}px ${this.bottom}px`
                            });
                            this.timeout = setTimeout(() => {
                                this.$em.css({
                                    transition: `background-position ${this.getTransitionDuration()}ms`,
                                    backgroundPosition: `0px ${this.bottom}px`
                                });
                            }, 25);
                        }, 250);
                    }
                })
                .on('mouseleave', () => {
                    if (this.o.hover === true) {
                        this.$em.css({
                            backgroundPosition: `-${this.width}px ${this.bottom}px`
                        });
                    } else if (this.o.hover === 'alternate') {
                        clearTimeout(this.timeout);
                        this.$em.css({
                            backgroundPosition: `0px ${this.bottom}px`
                        });
                    }
                });
        }
    }

    getAbsoluteWidth() {
        let width,
            $clone = this.$node.clone();

        $clone.addClass('absolute-width').after();
        this.$node.after($clone);
        width = $clone.find('.fancy-hover-em').width() + 1;
        $clone.remove();

        return width;
    }

    getTextShadow(fontSize, backgroundColor) {
        let size = Math.ceil(fontSize / (fontSize >= 30 ? 15 : 10)),
            textShadow = '';

        if (fontSize > 13) {
            if (fontSize > 1) size++;
            for (let i = 1; i <= size; i++) {
                if (i > 1) textShadow += ', ';
                textShadow += `
                -${i}px -${i}px ${backgroundColor},
                -${i}px 0 ${backgroundColor},
                0 ${i / 2}px ${backgroundColor},
                ${i}px 0 ${backgroundColor},
                ${i}px -${i}px ${backgroundColor}
            `;
            }
        }

        return textShadow;
    }

    getRealBackgroundColor($node) {
        let backgroundColor = $node.css('background-color');

        if (!$node.is('html')) {
            if (backgroundColor !== 'transparent' && backgroundColor !== 'rgba(0, 0, 0, 0)' && !$node.is('html'))
                return backgroundColor;
            else return this.getRealBackgroundColor($node.parent());
        } else return '#fff';
    }

    getTransitionDuration() {
        return 250;
        // return Math.max(this.width, 250);
    }

    getStrokeWidth(fontFamily, fontSize) {
        let slug = fontFamily.replace(/[^\w\s]/gi, '').replace(/ /gi, '-').toLowerCase(),
            strokeWidth = 1;

        if (slug === 'gilroy-arial-black-sansserif' || slug === 'gilroyarial-blacksansserif') {
            strokeWidth = Math.min(Math.max(Math.floor(fontSize / 10 - 1), 1), 6);
        }

        return strokeWidth;
    }

    getLetterHeight(fontFamily, fontSize) {
        let str = 'Hy',
            text = $(`<span>${str}</span>`),
            block = $('<div style="display: inline-block; width: 1px; height: 0;"></div>'),
            div = $('<div></div>'),
            descent = fontSize * 1.3,
            slug = fontFamily.replace(/[^\w\s]/gi, '').replace(/ /gi, '-').toLowerCase();

        if (!window.descendersMap[slug]) window.descendersMap[slug] = {};
        if (window.descendersMap[slug][fontSize]) {
            descent = window.descendersMap[slug][fontSize];
        } else {
            div.append(text, block);
            this.$em.after(div);

            let result = {},
                height = textHeight(str, {
                    family: fontFamily,
                    size: fontSize
                });

            block.css({ verticalAlign: 'baseline' });
            result.ascent = block.offset().top - text.offset().top;
            block.css({ verticalAlign: 'bottom' });
            result.height = block.offset().top - text.offset().top;
            result.descent = result.height - result.ascent;

            if ((slug === 'gilroy-arial-black-sansserif' || slug === 'gilroyarial-blacksansserif') && fontSize < 30) height.descent--;
            if (fontSize >= 30) height.descent--;
            if (fontSize >= 100) height.descent--;

            descent = result.ascent + height.descent;
            div.remove();
            if (height.descent !== descent) window.descendersMap[slug][fontSize] = descent;
        }

        return descent;
    }
}

$.fn.fancyHover = function(options = {}) {
    $(this).each((i, node) => {
        let $node = $(node);

        if (typeof options === 'object') $node.data('fancy-hover', new FancyHover(node, options));
        else if (options === 'redraw' && $node.data('fancy-hover')) $node.data('fancy-hover').createLine();
    });
};

export default $;



// WEBPACK FOOTER //
// ./sources/js/components/jquery-fancy-hover.js